import InstitutionAuthorisationForm from '@/features/institution/authorisation/components/form';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingAuthorisationPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="authorisation" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionAuthorisationForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingAuthorisationPage.displayName = 'InstitutionOnboardingAuthorisationPage';

export default InstitutionOnboardingAuthorisationPage;
